module.exports = __webpack_public_path__ + "static/media/digitalmarketing.d31fcf8f.jpg";